const moment = require("moment-timezone");

const states = [
    { path: '/' },
    { path: '/identity_provider',
        stateInit:
            {
                prompts: new Map(),
                prompt_content: new Map(),
                flags: [false, false],
                toggleItem: null,
                offSet: 0,
                pageCount: 1,
                perPage: 20,
                currentPage: 0,
                usernameReq: false,
                totalUsers: 0,
                totalAnonymous: 0,
                totalKnown: 0,
                idpList: [],
                filterList: [],
                topChannel: "",
                promptScroll: 0,
                searchFilter: "csi",
                selectedIDP: null,
                selectedIdpIndex: null
              }
    },
    {
        path: '/live',
        stateInit:
        {
            dropdownOpen: false,
            startDate: null,
            endDate: null,
            startDateComp: null,
            endDateComp: null,
            compLabel: "",
            compSelected: false,
            trafficData: {
              labels: null,
              values: null
            },
            labels: [],
            dataSets: [],
            activeConversations: {},
            channelIntervals: new Map()
        }
    },
    {
        path: '/callback-service',
        stateInit: {
        }
    },
    {
        path: '/survey',
        statInit: {
        }
    },
    {
        path: '/conversations',
        stateInit:
        {
            dropdownOpen: false,
            channelsData: null,
            versions: [],
            selectedVersion: {},
            conversationsData: null,
            trainingPhraseData: null,
            intentData: null,
            messagesData: [],
            selectedChannel: 0,
            selectedConversation: null,
            startDate: moment().startOf('day').subtract(7, 'days'),
            endDate: moment().endOf('day'),
            pageCount: 0,
            offSet: 0,
            perPage: 100,
            currentPage: 0,
            savedFilterList: [],
            savedFilterValue: null,
            errorFilter: false,
            errorCompareOp: ">=",
            errorThreshold: 0,
            stepsFilter: true,
            stepsCompareOp: ">",
            stepsThreshold: 20,
            ratingFilter: false,
            ratingCompareOp: null,
            ratingThreshold: null,
            searchFilter: false,
            searchValue: null,
            promptFilter: false,
            promptValue: null,
            intentFilter: false,
            intentValue: [],
            tagFilter: false,
            notesFilter: false,
            missingIntentFilter: false,
            missingInputFilter: false,
            tagValue: [],
            tags: null,
            tagMap: new Map(),
            promptScrollConversationDetails: 0,
            similarityList: [],
            dateFilter: true,
            startDateFilterValue: moment().startOf('day').subtract(7, 'days'),
            endDateFilterValue: moment().endOf('day'),
            transferEndpointFilter: false,
            transferEndpointValue: null,
            transferIdFilter: false,
            transferIdValue: null,
            channelFilter: false,
            channelValue: null,

            languageFilter: true,
            languageValue: "English",

            nluFilter: false,
            nluCompareOp: ">=",
            nluThreshold: 0,
            asrFilter: false,
            asrCompareOp: ">=",
            asrThreshold: 0,
            channelTransferFilter: false,
            channelTransferValue: null

          }
    },
    {
        path: '/conversations/:conversationId',
        stateInit:
        {
            dropdownOpen: false,
            channelsData: null,
            conversationsData: null,
            trainingPhraseData: null,
            intentData: null,
            messagesData: [],
            selectedChannel: 0,
            selectedConversation: null,
            startDate: moment().startOf('day').subtract(7, 'days'),
            endDate: moment(),
            pageCount: 0,
            offSet: 0,
            perPage: 100,
            currentPage: 0,
            savedFilterList: [],
            savedFilterValue: null,
            errorFilter: false,
            errorCompareOp: ">=",
            errorThreshold: 0,
            stepsFilter: false,
            stepsCompareOp: null,
            stepsThreshold: null,
            ratingFilter: false,
            ratingCompareOp: null,
            ratingThreshold: null,
            searchFilter: false,
            searchValue: null,
            promptFilter: false,
            promptValue: {value: null, label: null},
            intentFilter: false,
            intentValue: [],
            tagFilter: false,
            tagValue: [],
            tags: null,
            tagMap: new Map(),
            promptScrollConversationDetails: 0,

          }
    },
    {
        path: '/conversationsLite',
        stateInit:
        {
            dropdownOpen: false,
            channelsData: null,
            conversationsData: null,
            trainingData: null,
            messagesData: [],
            selectedConversation: null,
            startDate: moment().startOf('day').subtract(7, 'days'),
            endDate: moment(),
            pageCount: 0,
            offSet: 0,
            perPage: 100,
            currentPage: 0,
            errorFilter: false,
            errorCompareOp: ">=",
            errorThreshold: 0,
            stepsFilter: false,
            savedFilterList: [],
            savedFilterValue: null,
            confidenceFilter: false,
            confidenceCompareOp: null,
            confidenceThreshold: null,
            searchFilter: false,
            searchValue: null,
            promptFilter: false,
            promptValue: null,
            intentFilter: false,
            intentValue: null,
            tagFilter: false,
            tagValue: [],
            tags: null,
            tagMap: new Map(),
            notesFilter: false,
            sysEvtsFilter: false,
            sysEvtsFilterValue: null,

            transferEndpointFilter: false,
            transferEndpointValue: null,

            promptScroll: 0,
            dmPrediction: null,

            similarityList: []
          }
    },
    {
        path: '/user_activity',
        stateInit:
        {
            dropdownOpen: false,
            channelsData: null,
            conversationsData: null,
            messagesData: [],
            trainingPhraseData: null,
            selectedChannel: 0,
            selectedConversation: null,
            startDate: moment()
              .startOf("day")
              .subtract(7, "days"),
            endDate: moment().endOf("day"),
            pageCount: 0,
            offSet: 0,
            perPage: 100,
            currentPage: 0,
            errorFilter: false,
            errorCompareOp: ">=",
            errorThreshold: 0,
            stepsFilter: false,
            stepsCompareOp: null,
            stepsThreshold: null,
            ratingFilter: false,
            ratingCompareOp: null,
            ratingThreshold: null,
            searchFilter: false,
            searchValue: null,
            promptFilter: false,
            promptValue: null,
            intentFilter: false,
            intentValue: null,
            tags: null,
            tagMap: new Map(),
            userId: null,
            visible2: false,
            alert1: false,
            alert2: false,
            canDeleteUser: false,
            metadata: null,
            taskData: null,
            idp: null,
            canPurge: false,
            promptScrollConversations: 0,
            promptScrollMetadata: 0,
            promptScrollConversationDetails: 0,
            guid: null,
            userIntents: [],
            intentData: null,
            intentsLoading: false,
            userInfoLoading: false,
            userConversationsLoading: false
        }
    },
    { path: '/prompts',
        stateInit:
        {
            versions: [],
            selectedVersion: {
                id: -1,
                name: "",
                description: "",
                notes: "",
                author: ""
            },
            editVersionName: null,
            editVersionDescription: null,
            editVersionNotes: null,
            createVersionName: null,
            createVersionDescription: null,
            createVersionNotes: null,
            importLive: false,
            cloneVersionName: null,
            hideEmptyNameWarning: true,
            hideDuplicateNameWarning: true,
            deleteStatus: false,
            cloneStatus: false,
            createVersionDisabled: false,
            cloneVersionDisabled: false,
            deleteVersionDisabled: false,
            addPromptDisabled: false,
            modal2: false,
            modal3: false,
            prompts: new Map(),
            promptList: [],
            prompt_content: new Map(),
            flags: [false, false],
            toggleItem: null,
            modal: false,
            deleteModal: [false, false],
            pName: null,
            pText: null,
            pVoice: null,
            pSpanish: null,
            pSpanishVoice: null,
            searchFilter: "PromptName",
            filterList: [],
            offSet: 0,
            perPage: 30,
            pageCount: 0,
            currentPage:0,
            searchValue: null,
            promptsTotal: 0,
            promptNew: true,
            promptGroupOptions: [],

            audioList: []
          }
    },
    { path: '/prompts/import',
        stateInit: {
            selectedVersionId: -1,
            fileURL: ""
          },
        reroute: false
    },
    { path: '/prompts/groups',
        stateInit: {
            selectedVersionId: -1,
            promptGroupOptions: []
        },
        reroute: false
    },
    { path: '/user_satisfaction',
        stateInit:
        {
            dropdownOpen: false,
            selectedInterval: 2,
            ratingsData: {
              labels: null,
              values: null
            }
        }
    },
    {
        path: '/intents&entities',
        stateInit:
        {
            versions: [],
            selectedVersion: {
                id: -1,
                name: "",
                description: "",
                notes: "",
                author: "",
                freeze: null
            },
            editVersionName: null,
            editVersionDescription: null,
            editVersionReleaseDate: null,
            editVersionNotes: null,
            freezeVersion: null,
            createVersionName: null,
            createVersionDescription: null,
            createVersionNotes: null,
            createVersionReleaseDate: null,
            cloneVersionName: null,
            hideEmptyNameWarning: true,
            hideDuplicateNameWarning: true,
            cloneStatus: false,
            deleteStatus: false,
            createVersionDisabled: false,
            cloneVersionDisabled: false,
            deleteVersionDisabled: false,
            addIntentDisabled: false,
            addEntityDisabled: false,
            intents: [],
            entities: [],
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            newEntity: null,
            newIntent: null,
            intentScroll: 0,
            enititiesScroll: 0,
            isNewIntent: true,
            isNewEntity: true,
            activeVersion: null,
            lastExport: null
        },
        reroute: false
    },
    { path: '/intents&entities/import',
        stateInit: {
            fileURL: "",
            versions: [],
            selectedVersion: null,
            showError: false
        },
        reroute: false
    },
    { path: '/intents&entities/addintent', reroute: false},
    {
        path: '/intents&entities/intentdetails',
        stateInit:{
            phrases: [],
            phraseSubset: [],
            versionTrainingPhrases: [],
            hideEmptyNameWarning: true,
            hideDuplicateNameWarning: true,
            searchValue: null,
            flags: [false, false],
            deleteModal: [false, false],
            deleteIntent: false,
            entities: null,
            mymap: null,
            theMap: new Map(),
            entitiesMap: {},
            entitiesMapR: {},
            buttons: [false],
            newId: null,
            promptScroll: 0,
            isNewTrainingPhrase: true,
            hideEmptyTrainingPhraseWarning: true
          },

    },
    {
        path: '/admin',
        stateInit:{
          },

    },
    {
        path: '/admin/reigister',
        stateInit:{
          },

    },
    {
        path: '/intents&entities/entitydetails',
        stateInit:{
                synonymsMap: null,
                deleteEntity: false,
                url: null
              }
    },
    { path: '/hydra_states',
        stateInit:
        {
        }
    },
    {
        path: '/testHarness',
        stateInit:
        {
        },

    },
    { path: '/reporting',
        stateInit:
        {
        }
    },
    {
        path: '/user/profile',
        stateInit:
        {
            firstName: null,
            lastName: null,
            email: null,
            username: null,
            company: null,
        },

    },
    {
        path: '/flow',
        stateInit: {
            sankeyTypes: ['All', 'Success', 'Failure'],
            sankeyLanguages: ['All', 'English', 'Spanish'],
            selectedType: 'All',
            selectedLang: 'All',
            filter: ["ONETIME_PAYMENT"],
            key: 0,
            data: null,
        }
    }
  ];

  export default states;
